<template>
  <div class="scroll-wrapper branches-page">
    <div class="container-fluid branches-shell">
      <div class="branches-head">
        <div>
          <p class="branches-kicker">Настройки сети</p>
          <h3 class="branches-page-title">Филиалы</h3>
        </div>
      </div>
      <div class="branch-content">
        <el-card class="branches-card">
          <div class="branches-layout">
            <div class="branches-tree-column">
              <div class="branches-tree-shell">
                <el-tree ref="tree" :data="treeData" node-key="id" @node-expand="handleNodeExpand"
                         @node-collapse="handleNodeCollapse">
                <template #default="{ data }">
                  <div class="branch-node">
                    <font-awesome-icon v-if="data.type === 'city'" icon="city" class="branch-node__icon" />
                    <font-awesome-icon v-else-if="data.type === 'branch'" icon="building" class="branch-node__icon" />
                    <font-awesome-icon v-else-if="data.type === 'room'" icon="chair" class="branch-node__icon" />
                    <div class="title">{{ data.name }}</div>
                    <div class="time-working" v-if="data.type === 'branch' || data.type === 'room'">
                      ({{ getWorkingHours(data) }})
                    </div>
                    <div v-if="data.type === 'branch'" class="branch-node__actions">
                      <el-button class="branch-node__action branch-node__action--primary" text :icon="Plus"
                                 @click.stop="showAddRoomDialog(data)">кабинет
                      </el-button>
                      <el-button class="branch-node__action branch-node__action--icon" text @click.stop="editBranch(data)"
                                 size="small">
                        <font-awesome-icon icon="pen-to-square" class="branch-node__action-icon branch-node__action-icon--edit" />
                      </el-button>
                      <el-button class="branch-node__action branch-node__action--icon" text @click.stop="deleteBranch(data)" size="small">
                        <font-awesome-icon icon="trash-can" class="branch-node__action-icon branch-node__action-icon--delete" />
                      </el-button>
                    </div>
                    <div v-if="data.type === 'city' && (expandedNodes.includes(data.id) || data.children.length === 0)"
                         class="branch-node__actions branch-node__actions--city">
                      <el-button class="branch-node__action branch-node__action--primary" text :icon="Plus"
                                 @click.stop="showAddBranchDialog(data)">филиал
                      </el-button>
                      <el-button class="branch-node__action branch-node__action--icon" text @click.stop="editCity(data)" size="small">
                        <font-awesome-icon icon="pen-to-square" class="branch-node__action-icon branch-node__action-icon--edit" />
                      </el-button>
                      <el-button class="branch-node__action branch-node__action--icon" text @click.stop="deleteCity(data)" size="small">
                        <font-awesome-icon icon="trash-can" class="branch-node__action-icon branch-node__action-icon--delete" />
                      </el-button>
                    </div>
                    <div v-if="data.type === 'room'" class="branch-node__actions branch-node__actions--room">
                      <el-button class="branch-node__action branch-node__action--icon" text @click.stop="editRoom(data)" size="small">
                        <font-awesome-icon icon="pen-to-square" class="branch-node__action-icon branch-node__action-icon--edit" />
                      </el-button>
                      <el-button class="branch-node__action branch-node__action--icon" text @click.stop="deleteRoom(data)" size="small">
                        <font-awesome-icon icon="trash-can" class="branch-node__action-icon branch-node__action-icon--delete" />
                      </el-button>
                    </div>
                  </div>
                </template>
                </el-tree>
              </div>
            </div>
            <div class="branches-side-column">
              <div class="branches-side-panel">
                <span class="branches-side-label">Быстрое действие</span>
                <p class="branches-side-text">Добавляйте новые города и затем раскрывайте их до филиалов и кабинетов.</p>
                <el-button type="primary" class="branches-add-btn" @click="addCity">Добавить город</el-button>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
  <AddCity ref="addCity" />
  <ModalBranch ref="modalBranch" @update-city="updateCity" />
  <ModalRoom ref="modalRoom" @update-branch="updateBranch" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBuilding, faChair, faCity, faPenToSquare, faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Plus } from '@element-plus/icons-vue'
import store from '@/components/store/store'
import ModalBranch from '@/components/views/modal/ModalBranch.vue'
import ModalRoom from '@/components/views/modal/ModalRoom.vue'
import AddCity from '@/components/views/modal/ModalCity.vue'
import { mapState } from 'vuex'

library.add(faCity, faBuilding, faChair, faPenToSquare, faTrashCan)

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Branches',
  computed: {
    Plus() {
      return Plus
    },
    ...mapState('cities', ['cities']),
    treeData() {
      return this.cities
    }
  },
  components: { AddCity, ModalBranch, ModalRoom, FontAwesomeIcon },
  data() {
    return {
      expandedNodes: [],
      showAddCityDialog: false,
      newCity: { name: '', id: null, type: 'city', children: [] },
      showAddBranchDialogVisible: false,
      selectedNode: null,
      showAddRoomDialogVisible: false,
      editNodeDialogVisible: false,
      editingNode: {},
      editRoomDialogVisible: false,
      editingOffice: {},
      defaultWorking: {
        start: '8:00',
        end: '21:00'
      }
    }
  },
  async created() {
    await this.$store.dispatch('cities/getCities');
  },
  methods: {
    updateBranch(city_id, branch_id) {
      this.$nextTick(() => {
        for (let i in this.$refs.tree.store.root.childNodes) {
          if (this.$refs.tree.store.root.childNodes[i].data.id === city_id) {
            this.$refs.tree.store.root.childNodes[i].expanded = true
            break
          }
        }
        for (let i in this.$refs.tree.store.nodesMap) {
          if (this.$refs.tree.store.nodesMap[i].data.id === branch_id) {
            this.$refs.tree.store.nodesMap[i].expanded = true
            break
          }
        }
      })
    },
    updateCity(id) {
      this.$nextTick(() => {
        for (let i in this.$refs.tree.store.root.childNodes) {
          if (this.$refs.tree.store.root.childNodes[i].data.id === id) {
            this.$refs.tree.store.root.childNodes[i].expanded = true
            break
          }
        }
      })
    },
    addCity() {
      this.$refs.addCity.open()
    },
    showAddBranchDialog(node) {
      this.selectedNode = node
      this.$refs.modalBranch.open({
        id: null,
        city_id: node.id,
        name: '',
        working: {
          start: null,
          end: null
        }
      }, node.name)
    },
    showAddRoomDialog(node) {
      this.selectedNode = node
      const city_name = this.findCityName(node.city_id)
      this.$refs.modalRoom.open({
        id: null,
        city_id: node.city_id,
        branch_id: node.id,
        working: {
          start: node.working.start,
          end: node.working.end
        }
      }, city_name, node.name)
    },
    editRoom(node) {
      this.editingNode = node
      const city_name = this.findCityName(node.city_id)
      let branch_name = ''
      const searchCity = this.treeData.find(city => city.id === node.city_id)
      if (searchCity) {
        const searchBranch = searchCity.children.find(city => city.id === node.branch_id)
        if (searchBranch) {
          branch_name = searchBranch.name
        }
      }
      this.$refs.modalRoom.open(node, city_name, branch_name)
    },
    handleNodeExpand(data) {
      this.expandedNodes.push(data.id)
    },
    handleNodeCollapse(data) {
      this.expandedNodes = this.expandedNodes.filter(id => id !== data.id)
    },
    deleteBranch(branch) {
      this.$confirm(`Вы уверены, что хотите удалить кабинет "${branch.name}"? <br> <small style="color: #ff7b00">Если есть вложение кабинетов, они так же будут удалены!</small>`, 'Внимание', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(async () => {
        await store.dispatch('cities/removeBranch', { id: branch.id })
        this.updateBranch(branch.city_id)
        this.$message({
          type: 'success',
          message: 'Кабинет удален'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Удаление отменено'
        })
      })
    },
    editBranch(room) {
      const name = this.findCityName(room.id)
      this.$refs.modalBranch.open(room, name)
    },
    deleteRoom(node) {
      const message = `Вы уверены, что хотите удалить кабинет "${node.name}"?`
      this.$confirm(message, 'Внимание', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning'
      }).then(async () => {
        await store.dispatch('cities/removeRoom', { id: node.id })
        this.updateBranch(node.city_id, node.branch_id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Удаление отменено'
        })
      })
    },
    editCity(node) {
      this.editingNode = node
      this.$refs.addCity.edit(node)
    },
    deleteCity(node) {
      let message = `Вы уверены, что хотите удалить город "${node.name}"? <br> <small style="color: #ff7b00">Это также удалит все филиалы и кабинеты, связанные с ним.</small>`
      this.$confirm(message, 'Внимание', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(async () => {
        await store.dispatch('cities/deleteCity', { id: node.id })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Удаление отменено'
        })
      })
    },
    findCityName(branchId) {
      let cityName = ''
      for (let i in this.treeData) {
        const search = this.treeData[i].children.find(item => item.id === branchId)
        if (search) {
          cityName = this.treeData[i].name
          break
        }
      }
      return cityName
    },
    getWorkingHours(data) {
      return data.working.start + ' - ' + data.working.end
    }
  }
}
</script>
<style>
.branches-page .el-tree-node__content {
  min-height: 52px;
  height: auto;
  padding: 6px 8px;
  border-radius: 14px;
  margin-bottom: 8px;
}

.branches-page .el-tree-node:focus > .el-tree-node__content,
.branches-page .el-tree-node__content:hover {
  background-color: rgba(255, 255, 255, 0.04);
}
</style>
<style scoped>
.branches-page {
  height: 100%;
  overflow-y: auto;
  padding: 24px 18px 28px;
  background:
    radial-gradient(circle at top left, rgba(22, 61, 124, 0.34), transparent 34%),
    linear-gradient(180deg, #091325 0%, #07111f 100%);
}

.branches-shell {
  max-width: 1240px;
}

.branches-head {
  margin-bottom: 18px;
}

.branches-kicker {
  margin: 0 0 6px;
  color: rgba(174, 194, 230, 0.64);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
}

.branches-page-title {
  margin: 0;
  color: #f5f9ff;
  font-family: "Oswald", sans-serif;
  font-size: 32px;
  font-weight: 500;
}

.branch-content {
  padding: 0;
}

.branches-card {
  border: none;
  background: transparent;
}

.branches-card :deep(.el-card__body) {
  padding: 0;
}

.branches-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(260px, 0.72fr);
  gap: 18px;
}

.branches-tree-shell,
.branches-side-panel {
  height: 100%;
  border-radius: 22px;
  border: 1px solid rgba(110, 146, 214, 0.18);
  background: linear-gradient(180deg, rgba(10, 26, 52, 0.96), rgba(7, 18, 36, 0.94));
  box-shadow: 0 24px 48px rgba(2, 8, 18, 0.34);
}

.branches-tree-shell {
  padding: 18px;
}

.branches-side-panel {
  padding: 22px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 14px;
}

.branches-side-label {
  color: rgba(174, 194, 230, 0.62);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.3px;
  text-transform: uppercase;
}

.branches-side-text {
  margin: 0;
  color: #9bb4d8;
  font-size: 14px;
  line-height: 1.5;
}

.branches-add-btn {
  min-height: 42px;
  border: none;
  border-radius: 14px;
  background: linear-gradient(135deg, #00c3fe, #2b7cff);
  box-shadow: 0 16px 32px rgba(0, 123, 255, 0.2);
}

.branch-node {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
  color: #e3eeff;
}

.branch-node__icon {
  color: #00c3fe;
  font-size: 14px;
}

.title {
  font-size: 16px;
  font-weight: 500;
  color: #f5f9ff;
}

.time-working {
  color: rgba(174, 194, 230, 0.72);
  font-size: 12px;
}

.branch-node__actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.branch-node__action {
  margin-left: 0 !important;
}

.branch-node__action--primary {
  color: #00c3fe !important;
  font-size: 12px;
}

.branch-node__action--icon {
  width: 28px;
  height: 28px;
}

.branch-node__action-icon {
  font-size: 12px;
}

.branch-node__action-icon--edit {
  color: #00c3fe;
}

.branch-node__action-icon--delete {
  color: #ff6b81;
}

.branches-page :deep(.el-tree) {
  background: transparent;
  color: #d7e7ff;
}

.branches-page :deep(.el-tree-node__expand-icon) {
  color: rgba(174, 194, 230, 0.72);
}

.branches-page :deep(.el-button--text) {
  color: #00c3fe;
}

@media (max-width: 900px) {
  .branches-layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .branches-page {
    padding: 16px 12px 22px;
  }

  .branches-page-title {
    font-size: 28px;
  }

  .branches-tree-shell,
  .branches-side-panel {
    border-radius: 18px;
  }

  .branches-tree-shell {
    padding: 14px;
  }

  .branch-node {
    align-items: flex-start;
  }

  .branch-node__actions {
    width: 100%;
    margin-left: 0;
    padding-left: 22px;
  }
}

@media (max-width: 420px) {
  .branches-page .el-tree-node__content {
    padding: 8px 6px;
  }

  .title {
    font-size: 15px;
  }
}
</style>
